export const config = {
  title: 'CL James Remodeling | Remodeling Services in Winston Salem, NC',
  meta: {
    description:
      'CL James Remodeling provides exceptional remodeling services in Winston Salem, NC. Offering quality craftsmanship, terrific customer service, and the best remodeling in the county.',
    keywords: [
      'Remodeling Services Winston Salem NC',
      'Home Renovation',
      'Kitchen Remodeling',
      'Bathroom Remodeling',
      'CL James Remodeling',
      'MyBizSolutions LLC',
      'BizSolutions LLC',
    ],
    author: 'CL James Remodeling',
    canonicalUrl: 'https://cljamesremodeling.com/',
  },
  sections: {
    header: {
      businessName: 'CL James Remodeling',
    },
    sectionB: {
      heroTitle: 'CL James Remodeling',
      heroSubtitle: 'Transforming Homes with Quality Craftsmanship and Exceptional Service',
      learnAboutText: 'Explore Services',
      phoneNumber: '3366926411',
      phoneLabel: '(336) 692-6411',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1418465051/photo/aerial-view-of-modern-backyard-with-vegetable-garden.jpg?s=612x612&w=0&k=20&c=a_3DxsLc_F_OS4M3CtUWia2mFNgqErFCFYBm9qiYs4k=',
      cardData: [
        {
          title: 'Kitchen Remodeling',
          description:
            'Revamp your kitchen into a modern, functional, and stylish space tailored to your needs.',
        },
        {
          title: 'Bathroom Renovations',
          description:
            'Transform your bathroom with luxurious designs and high-quality craftsmanship.',
        },
        {
          title: 'Whole Home Remodeling',
          description:
            'We offer full-service remodeling to give your home a complete makeover.',
        },
      ],
      description:
        'CL James Remodeling is committed to delivering the highest quality remodeling services, ensuring your home reflects your style and meets your needs. From kitchens to bathrooms and beyond, we bring your vision to life.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'We specialize in remodeling services that bring beauty and functionality to your home. From kitchen upgrades to full-home renovations, our experienced team ensures quality results.',
      cards: [
        {
          title: 'Kitchen Remodeling',
          description:
            'Upgrade your kitchen with modern designs, premium materials, and exceptional craftsmanship.',
          imageSrc:
            'https://media.istockphoto.com/id/1093917492/photo/joinery-team-fitting-a-kitchen.jpg?s=612x612&w=0&k=20&c=IQcKUbT8klj_Qy482Wj2xBfKvw5aS00EQ8ziKdNBABI=',
          imageAlt: 'Kitchen Remodeling',
        },
        {
          title: 'Bathroom Renovations',
          description:
            'Create a spa-like retreat with our luxurious bathroom remodeling services.',
          imageSrc:
            'https://media.istockphoto.com/id/2149172961/photo/home-remodel-diy-bathroom-improvments.jpg?s=612x612&w=0&k=20&c=0Z8S_epW4x0VZuoV3jq-ISXIH4o9DKaFJa7UpPwijaI=',
          imageAlt: 'Bathroom Renovations',
        },
        {
          title: 'Home Additions',
          description:
            'Expand your living space with expertly crafted home additions tailored to your lifestyle.',
          imageSrc:
            'https://media.istockphoto.com/id/925489144/photo/apartment-repair-wall-repair-renovation-house-renovation-home-remodeling-real-estate-repair.jpg?s=612x612&w=0&k=20&c=iPVMNlzKmg3ltzHwVYpIIvxC64BO2arDVJtshTteDFE=',
          imageAlt: 'Home Additions',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Basement Finishing',
        'Flooring Installation',
        'Interior Painting',
        'Deck Construction',
        'Custom Cabinetry',
        'Windows and Doors Installation',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/1263778913/photo/beautiful-basement-entertaining-room-with-led-lighting-in-tray-ceiling.jpg?s=612x612&w=0&k=20&c=iiv2mX5f1WKQspSIr9hxyORZ79MuWwyLDzwdCNWigdw=',
        alt: 'CL James Remodeling Team',
      },
      aboutText: [
        'CL James Remodeling is a premier remodeling company based in Winston Salem, NC. With years of experience, we are passionate about creating stunning spaces that enhance the lives of our clients.',
        'Our commitment to quality craftsmanship and exceptional customer service sets us apart. Whether you need a simple upgrade or a complete home transformation, CL James Remodeling is here to bring your vision to life.',
      ],
    },
    sectionE: {
      profileImage: null, 
      profileAlt: 'CL James Remodeling Logo',
      businessName: 'CL James Remodeling',
      contact: {
        phone: '3366926411',
        phoneLabel: '(336) 692-6411',
        email: 'cjames_28@hotmail.com',
        website: 'https://cljamesremodeling.com/',
        address: '2978 Mathews View Ln, Winston Salem, NC 27105',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '2978 Mathews View Ln, Winston Salem, NC 27105',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.5760110136727!2d-78.63521!3d33.87091!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDUyJzE1LjciTiA3OMKwMzgnMTEuNCJX!5e0!3m2!1sen!2sus!4v1614123456789',
    },
  },
};

export default config;